export default __webpack_public_path__ + "static/media/verUltimaBoleta.fba202c8.svg";